<zelis-banner
  *ngIf="translateService.currentLang === 'es'"
  status="warn"
  [showMoreText]="'app_global_show_more' | translate"
  [showLessText]="'app_global_show_less' | translate"
  [translations]="'app_global_warn' | translate"
>
  <span>{{ 'medication_finder_banner_pre_link' | translate }}</span>
  <span class="banner-link" (click)="linkClick.emit()">{{
    'medication_finder_banner_link' | translate
  }}</span>
  <span>{{ 'medication_finder_banner_post_link' | translate }}</span>
</zelis-banner>
